import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pls-checkbox',
  templateUrl: './checkbox.component.html',
})
export class CheckboxComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
